import React from 'react'
import styled from 'styled-components'

const Loading = () => {
  return (
    <LoadingContainer>
      <Svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="status"
        aria-label="Cargando"
      >
        <style>{`
          .pt-dot-main {
            transform-origin: 50px 50px;
            animation: pt-pulse 1.4s ease-in-out infinite;
          }
          .pt-orbit {
            transform-origin: 50px 50px;
            animation: pt-orbit 2s linear infinite;
          }
          .pt-orbit-reverse {
            transform-origin: 50px 50px;
            animation: pt-orbit-reverse 3s linear infinite;
          }
          @keyframes pt-pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.1);
              opacity: 0.85;
            }
          }
          @keyframes pt-orbit {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes pt-orbit-reverse {
            from { transform: rotate(360deg); }
            to { transform: rotate(0deg); }
          }
        `}</style>

        <g className="pt-dot-main">
          <circle cx="50" cy="50" r="20" fill="#68AB44" />
          <text
            x="49"
            y="56"
            textAnchor="middle"
            fill="white"
            fontSize="18"
            fontWeight="700"
            fontFamily="Montserrat, sans-serif"
            letterSpacing="-1"
          >
            PT
          </text>
        </g>

        <g className="pt-orbit">
          <circle cx="50" cy="12" r="4" fill="#68AB44" opacity="0.6" />
          <circle cx="82" cy="30" r="3" fill="#68AB44" opacity="0.4" />
          <circle cx="88" cy="50" r="3.5" fill="#68AB44" opacity="0.5" />
        </g>

        <g className="pt-orbit-reverse">
          <circle cx="50" cy="83" r="3" fill="#68AB44" opacity="0.5" />
          <circle cx="18" cy="65" r="3.5" fill="#68AB44" opacity="0.6" />
          <circle cx="12" cy="50" r="3" fill="#68AB44" opacity="0.4" />
        </g>
      </Svg>
    </LoadingContainer>
  )
}

export default Loading

const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.98);
  display: flex;
  justify-content: center;
  align-items: center;
`

const Svg = styled.svg`
  width: clamp(84px, 10vw, 120px);
  height: auto;
`